import { Injectable } from '@angular/core';

export const keys = {
  userSites: 'userSites',
  sites: 'sites',
  regions: 'regions',
  characterStatus: 'characterStatus',
  roles: 'roles',
  region1Characters: 'region1Characters',
  region2Characters: 'region2Characters',
  unit: 'unit'
};

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private readonly _key = 'castmeas-spa';

  saveData(key: string, value: any) {
    localStorage.setItem(keys[key], JSON.stringify(value));
  }

  getData(key: string) {
    const data = localStorage.getItem(keys[key]) || '';

    return data ? JSON.parse(data) : null;
  }

  removeData(key: string) {
    localStorage.removeItem(keys[key]);
  }

  clearData() {
    localStorage.clear();
  }
}
